var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H1.875C1.77554 11 1.68016 10.9605 1.60983 10.8902C1.53951 10.8198 1.5 10.7245 1.5 10.625V6.5C1.5 5.30653 1.97411 4.16193 2.81802 3.31802C3.66193 2.47411 4.80653 2 6 2V2C7.19347 2 8.33807 2.47411 9.18198 3.31802C10.0259 4.16193 10.5 5.30653 10.5 6.5V6.5C10.5 7.69347 10.0259 8.83807 9.18198 9.68198C8.33807 10.5259 7.19347 11 6 11V11Z",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75586 10.9996C6.06611 11.8771 6.64084 12.6369 7.40088 13.1742C8.16091 13.7114 9.06884 13.9998 9.99961 13.9996H14.1246C14.2241 13.9996 14.3194 13.9601 14.3898 13.8898C14.4601 13.8194 14.4996 13.7241 14.4996 13.6246V9.49961C14.5012 8.34782 14.0605 7.23939 13.2685 6.40315C12.4764 5.56692 11.3935 5.06673 10.2434 5.00586",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2f643209.svg";
export { ForwardRef as ReactComponent };